import React, { memo, useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useWindowSize } from 'react-use';
import classnames from 'classnames';
import { CollectorScope } from 'graphql/types';
import { useScrollbarStyles } from 'modules/common/styles';
import { CopyrightFooter } from 'modules/common/components/CopyrightFooter';
import { useSidePanelContext } from 'modules/rootPage/SidePanelContext';
import { CollectorsListPage } from './CollectorsListPage';
import { useCompanyCollectors } from './hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    height: 'inherit',
    overflowX: 'hidden',
    overflowY: 'auto',
    background: theme.palette.information.pageBackground,
    width: ({ width }: { width: number }) => width,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  copyright: {
    marginTop: theme.spacing(4)
  }
}));

export const CompanyCollectorsTab: React.FC = memo(() => {
  const { pinned = false } = useSidePanelContext();
  const { width } = useWindowSize();
  const classes = useStyles({
    width: pinned ? width - 240 : width - 64
  });
  const classesScrollbar = useScrollbarStyles();
  const { data, loading } = useCompanyCollectors(CollectorScope.Tenant);

  return (
    <div className={classnames(classes.root, classesScrollbar.scrollbar)}>
      <CollectorsListPage
        scope={CollectorScope.Tenant}
        collectors={useMemo(() => ({ data, loading }), [data, loading])}
      />
      <CopyrightFooter className={classes.copyright}></CopyrightFooter>
    </div>
  );
});

CompanyCollectorsTab.displayName = 'CompanyCollectorsTab';
